module.exports = function (confirmationDialogService) {
    return {
        restrict: 'E',
        link(scope) {
            scope.confirmationDialog = confirmationDialogService;

            // Click Handlers
            scope.continue = confirmationDialogService.resolveDialog.bind(confirmationDialogService, true);
            scope.cancel = confirmationDialogService.resolveDialog.bind(confirmationDialogService, false);
        },
        template: require('./confirmation-dialog.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/confirmation-dialog/confirmation-dialog.directive.js